import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { Button, Result } from 'antd';
import type { FallbackProps } from 'react-error-boundary';

import { ROUTE_CONSTANTS } from '@/routes';

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleReset = () => {
    queryClient.clear();
    void navigate({ to: ROUTE_CONSTANTS.HOME_PATH });
    resetErrorBoundary();
  };

  const errorStatus = (error as any)?.response?.status ?? error?.status;
  switch (errorStatus) {
    case 403:
      return (
        <Result
          status='403'
          title='403'
          subTitle='Forbidden.'
          extra={
            <Button type='primary' onClick={handleReset}>
              Back to Apps
            </Button>
          }
        />
      );
    case 401:
      return (
        <Result
          status='403'
          title='401'
          subTitle={'Unauthorized'}
          extra={
            <Button type='primary' onClick={handleReset}>
              Home
            </Button>
          }
        />
      );
    case 404:
      return (
        <Result
          status='404'
          title='404'
          subTitle={'Not Found'}
          extra={
            <Button type='primary' onClick={handleReset}>
              Home
            </Button>
          }
        />
      );
    default:
      return (
        <Result
          status='warning'
          title={error.code}
          extra={
            <Button type='primary' onClick={handleReset}>
              Home
            </Button>
          }
        />
      );
  }
}

export default ErrorFallback;
